// extracted by mini-css-extract-plugin
module.exports = {"copy":"lead-module--copy--2kM40"};